import { EdgeClaimContactRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ClaimContact } from '@/modules/auth/use-cases'

export function makeClaimContact(): ClaimContact {
  return new EdgeClaimContactRepository(makeSupabaseEdgeHttpClient()).execute
}
